<template>
  <div class="qrcode-container" @click="$emit('close')" style="cursor:pointer;">
    <vue-qrcode
      class="qrcode"
      :width="width"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import VueQrcode from "vue-qrcode";
export default {
  name: "qrcodeModal",
  components: {
    VueQrcode,
  },
  data() {
    return {
      width:100,
    };
  },
  mounted() {
    this.handleOrientationChange();
    window.addEventListener("orientationchange", this.handleOrientationChange);
  },
  methods: {
    handleOrientationChange() {
      const orientation = window.screen.orientation.type;
      if (orientation === "portrait-primary") {
        this.width = window.screen.availWidth < 512? window.screen.availWidth : 512;
      } else if (orientation === "landscape-primary") {
        this.width = window.screen.availHeight < 512? window.screen.availHeight : 512;
      }
    },
  },
};
</script>

<style scoped>
.qrcode {
  object-fit: contain;
  max-width: 512px;
  margin: auto;
}
.qrcode-container {
  display: flex;
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.1s ease;
}
</style>